module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'fields',
		'select'
	],

	model: {
		defaultFields: {
			firstName: 	{ type: 'text', nameKey: 'newsletter.segmentsData.defaultFields.firstName', name: '', },
			lastName: 	{ type: 'text', nameKey: 'newsletter.segmentsData.defaultFields.lastName', name: '', },
			email: 		{ type: 'text', nameKey: 'newsletter.segmentsData.defaultFields.email', name: '', },
			createdAt: 	{ type: 'date', nameKey: 'newsletter.segmentsData.defaultFields.createdAt', name: '', },
		},
		operators: {
			all: ['eq','ne','lt','le','gt','ge','lk','nl'],
			byType: {
				text: ['eq','ne','lk','nl'],
				date: ['eq','ne','lt','le','gt','ge'],
			},
			byDataType: {
				'boolean': 					['eq','ne'],
				'category-picker': 			['lk','nl'],
				'custom': 					['eq','ne','lt','le','gt','ge','lk','nl'],
				'date': 					['eq','ne','lt','le','gt','ge'],
				'datetime': 				['eq','ne','lt','le','gt','ge'],
				'db-picker': 				[],
				'float': 					['eq','ne','lt','le','gt','ge'],
				'html': 					['eq','ne','lk','nl'],
				'integer': 					['eq','ne','lt','le','gt','ge'],
				'json': 					['eq','ne','lt','le','gt','ge','lk','nl'],
				'media-file': 				[],
				'media-image': 				[],
				'resource-picker': 			['lk','nl'], //['eq','ne','lk','nl'],
				'route-component-picker': 	['lk','nl'], //['eq','ne','lk','nl'],
				'route-picker': 			['lk','nl'], //['eq','ne','lk','nl'],
				'table': 					[],
				'tag-picker': 				['lk','nl'], //['eq','ne','lk','nl'],
				'template-picker': 			[],
				'text': 					['eq','ne','lk','nl'],
				'time': 					['eq','ne','lt','le','gt','ge'],
				'uuid': 					['eq','ne']
			}
		}
	},

	events: {
		change: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var self = event.data.component;
			var $target = $(event.target).closest('select');
			var value = $target.val();

			if(value === '') value = null;
			self.closest('base_form_form', function(form){
				form.childChanged({
					fieldCode: self.model.fieldCode,
					value: value
				});
			});

			self.updateFieldIcon($target, value);
		}
	},

	methods: {
		onBuild(storage){
			// TODO: POIA: CHECK TRANSLATIONS
			for(const field of Object.values(this.model.defaultFields || {})){
				field.name = storage.__(field.nameKey)
			}
		},

		dataDealer: function(){
			const storage = this.getStorage()
			var defaultFields = [];
			for(var defaultField in this.model.defaultFields){
				// defaultFields.push({ name: this.model.defaultFields[defaultField].name, value: defaultField, icon: this.getFieldDependentIcon(defaultField) })
				defaultFields.push({ name: this.model.defaultFields[defaultField].name, value: defaultField })
			}
			var fields = [];
			this.model.additionalFields = this.getResourceRegisterContent('mailingListAdditionalFields') || {};
			for(var field in this.model.additionalFields){
				// fields.push({ name: this.model.additionalFields[field].name, value: field, icon: this.getFieldDependentIcon(field) })
				fields.push({ name: this.model.additionalFields[field].name, value: field })
			}
			this.model['custom-data'] = [
				{ value: '', name: storage.__('newsletter.segmentsData.selectDefaultValues.defaultFields') },
				{ name: storage.__('newsletter.segmentsData.groupHeads.defaultFields'), 	children: defaultFields },
				{ name: storage.__('newsletter.segmentsData.groupHeads.mailingListFields'), children: fields }
			];
		},

		updateFieldIcon: function($target, value){
			var $field = $target.closest('.field');
			var $icon = $field.find('.templates_newsletter_segments_data_fields_segmentationFieldIcon');
			var $i = $icon.find('i');
			var icon = this.getFieldDependentIcon(value);
			if($i.length > 0) {
				if(icon) 	$i.attr('class', icon);
				else 		$icon.remove();
			}
			else if(icon){
				$field.prepend(this.include('./segmentationFieldIcon', { model: { icon } }));
			}
		},

		getFieldDependentOperators: function(fieldCode){
			if(!fieldCode) return this.model.operators.all;

			var type;
			if((type = (this.model.defaultFields[fieldCode] || {}).type)){
				return this.model.operators.byType[type] || this.model.operators.all;
			}

			if(
				((this.model.additionalFields[fieldCode] || {}).renderType === 'checkbox' && (this.model.additionalFields[fieldCode] || {}).dataType !== 'boolean')
				||
				(this.model.additionalFields[fieldCode] || {}).dataType === 'tag-picker'
			){
				return ['lk-and','nl-and','lk-or','nl-or'];
			}

			if((type = (this.model.additionalFields[fieldCode] || {}).dataType)){
				return this.model.operators.byDataType[type] || this.model.operators.all;
			}

			return this.model.operators.all;
		},

		getFieldDependentIcon: function(fieldCode){
			if(!fieldCode) return '';

			var type;
			if((type = (this.model.defaultFields[fieldCode] || {}).type)){
				if(type === 'text') return 'fi fi-newsletter-segment-segmentData-fieldType-text';
				if(type === 'date') return 'fi fi-newsletter-segment-segmentData-fieldType-date';
			}

			var dataType, renderType;
			if(
				(dataType = (this.model.additionalFields[fieldCode] || {}).dataType) &&
				(renderType = (this.model.additionalFields[fieldCode] || {}).renderType)
			){
				switch(dataType){
					case 'date':
					case 'datetime':
						return 'fi fi-newsletter-segment-segmentData-fieldType-date'

					case 'time':
						return 'fi fi-newsletter-segment-segmentData-fieldType-time'

					case 'text':
					case 'html':
					case 'uuid':
						return 'fi fi-newsletter-segment-segmentData-fieldType-text'

					case 'boolean':
						return 'fi fi-newsletter-segment-segmentData-fieldType-boolean'

					case 'float':
					case 'integer':
						return 'fi fi-newsletter-segment-segmentData-fieldType-number'
				}
				return 'fi fi-newsletter-segment-segmentData-fieldType-list';
			}

			return '';
		}
	},

	hooks: {
		attach: function($element, options){
			this.updateFieldIcon($element, $element.val());
		}
	}
};